import { Section, Eyebrow, P } from "../Chapter";
import { Reveal } from "../Reveal";

export const Turn = () => (
    <Section className="relative overflow-hidden">
        <span
            aria-hidden="true"
            className="pointer-events-none absolute left-1/2 top-1/2 -z-0 -translate-x-1/2 -translate-y-1/2 select-none font-deva text-[52vw] leading-none text-wax opacity-[0.07] md:text-[34rem]"
        >
            पत्र
        </span>

        <div className="relative">
            <div className="mx-auto max-w-[68ch] text-center">
                <Eyebrow>X. पत्र</Eyebrow>
            </div>
            <Reveal as="h2" className="mx-auto mb-12 max-w-[68ch] text-center font-serif text-4xl leading-[1.08] tracking-tight text-ink sm:text-5xl">
                So — about the name
            </Reveal>

            <P>
                In Hindi, a letter is called पत्र — <em className="italic">patra</em>. Not the
                letters of an alphabet. The kind you write to someone, fold, seal, and send. The word
                is old. It also means <em className="italic">leaf</em>, from when leaves were what
                people wrote on.
            </P>
            <P delay={0.05}>
                This domain is <span className="text-wax">patr.ai</span>. It belongs to Vinay
                Malviya, and he uses it as his email address.
            </P>
            <P delay={0.05}>
                Which means a message sent to him is, quite literally, sent to{" "}
                <em className="italic text-wax">letter</em> — carried by the fastest system humans
                have ever built, arriving at a name from the slowest one.
            </P>

            <Reveal className="mx-auto mt-16 max-w-[44rem] text-center">
                <p className="font-serif text-3xl italic leading-[1.3] text-ink md:text-4xl">
                    The road is faster now. That was never the hard part.
                </p>
                <p className="mt-8 font-serif text-3xl leading-[1.3] text-wax md:text-4xl">
                    Write to me here. Slowly, if you can.
                </p>
            </Reveal>
        </div>
    </Section>
);
